/** @deprecated Import from './stores/location-store' instead */
import { getLocationStore } from './stores/location-store'

export const store = {
  loadLocation: () => getLocationStore().loadLocation(),
  setLocation: (location: Parameters<ReturnType<typeof getLocationStore>['setLocation']>[0]) =>
    getLocationStore().setLocation(location),
}
